import * as HttpService from "../../../../service/HttpService";

/** 运行监控  -> 告警查询服务 **/

/**
 * 获取告警列表
 */
export const getAlertList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianSoeRecord/getPeidianSoeRecordVoList", params);
}

/**
 * 确认研判
 * @param deviceId 设备id
 * @param description 描述
 */
export const confirmAlert = (deviceId, description) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianSoeRecord/insertSoeRecordHandle", {id: deviceId, archiveDesc: description});
}
